import React, { PropTypes } from "react";
import ComponentRegistry from "../../Common/ComponentRegistry"

export default class VariationController extends React.Component {
    constructor(props) {
        super(props);

        this.store = ComponentRegistry.getStore("ProductStore");
    }
    render() {
        if (Object.keys(this.props.properties).length === 0) {
            return null;
        }

        const Property = ComponentRegistry.get("ProductPurchaseAtomsProperty");
        const VariationView = ComponentRegistry.get(this.props.view);

        const properties = [];
        Object.keys(this.props.properties).forEach((property) => {
            if (this.props.properties[property].is_dropdown) {
                const availableChoices = this.store.getFilteredValues(property);
                const choices = this.props.onlyAvailable ? availableChoices : this.store.getValues(property);

                properties.push(<Property
                  {...this.props.properties[property]}
                  key={property}
                  choices={choices}
                  availableChoices={availableChoices}
                  onChange={value => this.store.filter(property, value)}
                />);
            }
        });
        return <VariationView>{properties}</VariationView>;
    }
}
VariationController.propTypes = {
    view: PropTypes.string.isRequired,
    properties: PropTypes.oneOfType([PropTypes.objectOf(PropTypes.shape({
        is_dropdown: PropTypes.bool.isRequired,
    })), PropTypes.arrayOf(PropTypes.shape({}))]),
    onlyAvailable: PropTypes.bool.isRequired,
};

VariationController.defaultProps = {
    view: "ProductPurchaseViewsVariationView",
    onlyAvailable: false,
};



// WEBPACK FOOTER //
// ./src-js/Fratello/ProductPurchase/Controllers/VariationController.jsx